//--------------------------------------------------
// imported classes
//--------------------------------------------------
const Match = require('@/tbs/model/to/Match')
const ClassFunc = require('@/tbs/util/ClassFunc')

/**
 * The Organization class works as the organization translator.
 */
const tbs_model_to_OrganizationManager = function() {
    //--------------------------------------------------
    // super method for the base class
    //--------------------------------------------------
    ClassFunc.super(this, Match, arguments);
}

//--------------------------------------------------
// prototype
//--------------------------------------------------
tbs_model_to_OrganizationManager.prototype = {
    'check-in-period': '入驻$num$unit',
    'team-list': '球队列表',
    'video-library': '视频库',
    'schedule-table': '赛程表',
    'referee-admin': '裁判管理',
    'staff-admin': '工作人员',
    'asset-library': '素材库',
    'mini-program': '机构小程序',
    'organization-info': '机构信息',
    'account': '账户',
    'go-account': '前往开户',
    'go-account-description': '完成认证，即可报名缴费',
    'go-auth': '前往认证',
    'go-auth-confirm-message': '开户前，请先完成机构认证',
}

//--------------------------------------------------
// extends the Match
//--------------------------------------------------
ClassFunc.extend(tbs_model_to_OrganizationManager, Match);

module.exports = tbs_model_to_OrganizationManager